import { createAction } from '@ngrx/store';

export namespace NavbarActions {
  enum NavbarActionTypes {
    ToggleHamburgerMenu = '[Navbar] Toggle hamburger menu',
  }

  export const toggleHamburgerMenu = createAction(NavbarActionTypes.ToggleHamburgerMenu);
}
